import Api from '@/services/api'

// let fetchStoreData = key => {
//   if (window.localStorage.getItem('PMGC-default') && window.localStorage.getItem('PMGC-default') !== null) {
//     return JSON.parse(JSON.parse(window.localStorage.getItem('PMGC-default')).value)[key]
//   } else {
//     return null
//   }
// }

// let header = {
//   headers: {
//     'x-access-token': fetchStoreData('token')
//   }
// }
export default {
  fetchQuestions (language) {
    // questionData.token = header.headers
    return Api().post('/questions/practice', language)
  },
  // fetch_questions (language) {
  //   return Api().post('/questions/practice-test', language)
  // },
  fetchAdminQuestions (data) {
    // questionData.token = header.headers
    return Api().get('/questions/admin', data)
  },
  fetchCandidates (data) {
    return Api().get('/admin/candidates', data)
  },
  fetchMemberCandidates (data) {
    return Api().get('/admin/members', data)
  },
  fetchMobilizerCandidates (data) {
    return Api().get('/admin/mobilizers', data)
  }
}



// WEBPACK FOOTER //
// ./src/services/fetchService.js